export const REVIEW_BLOCK = {
  TITLE: 'Thank you!',
  SUBTITLE: 'Your information has been submitted for review.',
  TITLE_APPROVED:
    'The information you have entered for this entity has been confirmed.',
  DESCRIPTION_APPROVED:
    'The page will become available once all required entities have been confirmed by us.',
  DESCRIPTION: 'We will keep you updated via email.',
  BUTTON_LABEL: 'Go to dashboard',
}
